import React, { Component } from 'react';
import { Flex, Toast } from 'antd-mobile';
import { RskashTermsMap } from './doc';
// 此页面为合同文案页面 尽量少写样式

class RskashLoanContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applicationId: '',
      termsData: RskashTermsMap,
      loanData: {},
    }
  }
  // 初始化
  componentDidMount() {
    document.title = 'RsKash Loan Sanction Letter';
    this.initTerms();
  }

  notifyApp() {
    Toast.success('notify app', 5);
  }

  getLoanData(obj, key) {
    if (obj) {
      return obj[key] || '--';
    }
    return '--';
  }

  initTerms() {
    if (window.android) {
      try {
        const loan = window.android.initLoanAgreement();
        const loanObj = loan ? JSON.parse(loan) : null;
        this.setState({
          loanData: loanObj,
          termsData: {
            ...this.state.termsData,
            'Application ID': this.getLoanData(loanObj, 'customerId'), // customerId
            'Sanction Date': this.getLoanData(loanObj, 'currDate'), // 借款日期 使用当前日期
            'Borrower':	this.getLoanData(loanObj, 'name'),
            'Borrower PAN':	this.getLoanData(loanObj, 'panCardNumber'), // pan号码
            'Principal Loan Amount':	this.getLoanData(loanObj, 'loanAmount'), // 贷款本金
            'Rate of Interest': this.getLoanData(loanObj, 'interest'),
            // 手续费
            'Processing Fees charged by the Service Provider': this.getLoanData(loanObj, 'paymentFee'),
            'Other fees [Charged by]': this.getLoanData(loanObj, 'otherFee'), // 其他费用
            'Amount to be Disbursed': this.getLoanData(loanObj, 'fee'), // 到手金额
            'Due Date':	this.getLoanData(loanObj, 'repayTenure'),
            'Repayment Amount': this.getLoanData(loanObj, 'repayAmount'), // 还款金额
            'Penalty Interest': '2% of loan amount per day', // 延迟还款罚息
          },
        })
      } catch (err) {
        console.log(err);
      }
    }
  }

  render() {
    const { termsData } = this.state;
    const tableMsg = Object.keys(termsData).map((_, index) => {
      return (<tr key={ index.toString() }>
        <td>{ index + 1 }</td>
        <td className='nowrap-name'>{ _ }</td>
        <td className='blue'>{ termsData[_] }</td>
      </tr>)
    })

    const userName = this.getLoanData(this.state.loanData, 'name');
    const cardAddress = this.getLoanData(this.state.loanData, 'currentAddress');
    const cardNo = this.getLoanData(this.state.loanData, 'panCardNumber');
    const phoneNumber = this.getLoanData(this.state.loanData, 'mobile');
    const localDate = this.getLoanData(this.state.loanData, 'currDate');

    return <Flex className='doc' direction='column'>
      <Flex.Item className='body'>
        {/* Loan Agreement */}
        <h2>Loan Agreement</h2>
        <p>This Loan Agreement (<b>Agreement</b>) is entered by electronic means on the day mentioned in the <b>Schedule of Loan Sanction Terms</b> of the agreement.</p>
        <p></p>
        <p><b>BY AND BETWEEN: </b></p>
        <p></p>
        <p><b>X10 Financial Services Limited</b>, A duly registered Non-Banking Financial Company registered with the Reserve Bank of India and incorporated in India under Companies Act 1956 with Corporate Identification Number (CIN)::U65990MH1994PLC080143 with Corporate office Address 3rd Floor, Kh. No 385/3 Opp. Corporation Bank,100 Feet Road, Ghitorni, New Delhi - 110 030 (India) and its contact email ID RsKash.app@x10corp.com (hereinafter referred to as the “Lender”, which expression shall, unless repugnant to or inconsistent with the context, mean and include their successors and permitted assignees)</p>
        <p></p>
        <p><b>and</b></p>
        <p></p>
        <p>Mr/Ms/Mrs. [{ userName }] an Indian resident with Permanent Account Number (PAN): { cardNo } Address [{ cardAddress }] email ID, Phone Number : { phoneNumber }(hereinafter referred to as the “Borrower”, which expression shall, unless repugnant to or inconsistent with the context, mean and include their successors and permitted assignees). </p>

        <p>Borrower and Lender shall together be referred to as the “Parties” and severally as the “Party”.</p>

        <p></p>
        <p><b>Witnesseth</b></p>
        <p></p>

        <p>Whereas, [<i>RSKASH</i>] (the “App”) is an online loan origination platform of [<i className="red">X10 Financial Services Limited</i>] “Service Provider” that markets personal loan product to borrowers. The Service Provider has entered into a Service Agreement with the Lender to originate and process loan applications received from various borrowers.</p>
        <p></p>

        <p>Whereas, the Lender is a Non-Banking Financial Company, engaged in the business to provide loans to individual and business customers in India;</p>
        <p></p>

        <p>Whereas the Borrower is an individual, who has registered on the App by creating his/her account, accepting various permission requests presented by the App, and applied for the Loan by furnishing the personal and income details and submitting required KYC documents and providing the undertaking as per this Agreement to avail the loan; and </p> 
        <p>Whereas the terms between the Borrower and the Lender are materialized by entering into this binding Agreement.</p>
        <p></p>

        <h3>NOW THEREFORE, IN CONSIDERATION OF THE MUTUAL PROMISES, COVENANTS AND CONDITIONS HEREINAFTER SET FORTH, THE RECEIPT AND SUFFICIENCY OF WHICH IS HEREBY ACKNOWLEDGED, THE PARTIES AGREE AS FOLLOWS:</h3>

        <ol>
          <li>
            <h4>Definitions and Interpretations</h4>
            <ol>
              <li>In this Agreement (including any recitals, annexure, schedules or exhibits attached) except where the context otherwise requires, the following words and expressions shall have the following meaning;</li>

              <li>“App” refers to the Mobile Application  [<i>RSKASH</i>] owned and published by  [<i className="red">X10 Financial Services Limited</i>], a private limited company incorporated under the provisions of the Companies Act, 2013  having its registered office at  [<i>No 48, 4th Block, Koramangala, Bengaluru Bangalore KA 560034 IN</i>]</li>

              <li>“Credit score” means the score or report as obtained from a recognized third party Credit Information Company</li>

              <li>“Indian Resident” is a person resident in India as defined under clause 2(v) of the Foreign Exchange Management Act, 1999.</li>

              <li>“Person” means an individual</li>

              <li>“Repayment” means the payment of the principal amount and of applicable loan interest, commitment or any other charges, fees or other dues payable in terms of this Agreement to the Lender by the Borrower.</li>

              <li>“Pre-payment” means premature repayment of the Loan in partial or full.</li>

              <li>“Instalment” means the amount of periodic  payment over the period of loan.</li>

              <li>“E Mandate” or “E NACH ” means the electronic mandate for auto debit from the bank account of the borrower for the amount of the Repayment Amount drawn by the borrower in favour of the lender.</li>

              <li>“Loan” means an advance of money by the Lender to the Borrower, upon the request of the Borrower, and which shall be a liability of the Borrower, on terms of this Agreement, as set forth in the Schedule of Loan Sanction Terms.</li>

              <li>“Working day” shall mean a day on which the Banks are open for business in India.</li>

              <li>References to Articles, Clauses, Recitals, Appendices and Schedules are to articles, clauses, recitals, appendices and schedules to this Agreement.</li>

              <li>Any reference to a statutory provision shall include such provision as is from time to time modified or re-enacted or consolidated so far as such modification or re-enactment or consolidation applies or is capable of applying to any transactions entered into hereunder.</li>

              <li>Words denoting the singular shall include the plural and vice versa.</li>

              <li>Words denoting the masculine gender shall include the feminine gender and vice versa.</li>


              <li>The Recitals to this agreement shall be and form an integral part of this agreement.</li>

              <li>Headings in this Agreement are for convenience of reference only and shall not be used to construe or interpret this agreement.</li>
            </ol>
          </li>
          <li>
            <h4>Commencement</h4>
            <p>This agreement shall come into effect from the date of this Agreement as recorded in the Schedule of Loan Sanction Terms appended to this agreement.</p>
          </li>
          <li>
            <h4>Borrower Acknowledgements and Confirmation:</h4>
            <p>Borrower hereby acknowledges and accepts the following;</p>
            <ol>
              <li>I have personally applied for the Loan on the App after confirming acceptance of the Terms and Conditions of Use and Privacy Policies listed on the App.</li>

              <li>I acknowledge that my Name, details of Permanent Account  Number (PAN) , Aadhaar Card or of any other Address and Identity proof are obtained by the Service provider and passed on to the Lender from the materials I have submitted in the App “[RSKASH]” as part of my personal profile and Loan application for review with my consent.</li>

              <li>I acknowledge that to register myself and use the App to apply the Loan I have  granted various permissions including but not limited to provide access to Camera, Media,  Location, Contact List, Phone Details, SMS and Call Records on my Smartphone. The data contained in some or all of these items would be used to process my application and establish my credit limit by the Service Provider, the Lender or the third parties engaged by them. </li>

              <li>I understand the terms of the Loan to be provided to me by the Lender are approved as per the internal policies and processes, and in their sole determination. </li>

              <li>I further acknowledge, understand and agree that Lender has adopted risk-based pricing, which is arrived by taking into account broad parameters like the customers financial and credit profile and information and data obtained from various permissions granted by me to the App. </li> 

              <li>I understand all the terms of this Agreement, and have had the opportunity to seek qualified advice, and thus make a Disbursement request of the Loan from the Lender and instruct the Lender to transfer the Loan amount to my bank account.</li>
            </ol>
          </li>
          <li>
            <h4>Borrower Undertaking</h4>
            <ol>
              <li>I represent that the information and details provided by me for the registration and loan application and the documents submitted by me on the App and by other means are true, correct and that I have not withheld any information.</li>

              <li>I have read and understood the fees and charges applicable to the Loan that I may avail </li>

              <li>I confirm that no insolvency proceedings or suits for recovery of outstanding dues have been initiated and / or are pending against me.</li>

              <li>I hereby authorize Lender to exchange or share information and details relating to this Application Form to its associate companies or any third party, as may be required or deemed fit, for the purpose of processing this loan application and/or related offerings or other products / services that I may apply for from time to time.</li>

              <li>I hereby consent to and authorize Lender to increase or decrease the credit limit assigned to me basis Lender's internal credit policy.</li>

              <li>By submitting this Application Form, I hereby expressly authorize Lender to send me communications regarding various financial products offered by or from Lender, its group companies and /or third parties through telephone calls / SMSs / emails / post etc. including but not limited to promotional communications and confirm that I shall not challenge receipt of such communications as unsolicited communication, defined under TRAI Regulations on Unsolicited Commercial Communications under the Do Not Call Registry.</li>

              <li>That Lender shall have the right to make disclosure of any information relating to me including personal information, details in relation to Loan, defaults, security, etc to CIBIL and other Credit Information Companies and/or any other governmental/regulatory/statutory or private agency / entity, RBI, KYC Registry, including publishing the name as part of wilful defaulter's list from time to time, and also use for KYC information verification, credit risk analysis, or for other related purposes. I consent to the lender to obtain my credit reports from the credit bureau agencies. </li>

              <li>I agree and accept that Lender may in its sole discretion, by itself or through authorized persons, advocate, agencies, bureau, etc. verify any information given including  checking credit references and details of the employment.</li>

              <li>That the funds shall be used for the Purpose specified the SCHEDULE OF LOAN SANCTION TERMS will not be used for speculative or antisocial purpose.</li>

              <li>I have understood and accepted the late payment and other default charges listed in the SCHEDULE OF LOAN SANCTION TERMS.</li>

              <li>I confirm that I possess the smartphone and the phone number I have used to the register and apply the Loan on the APP. I agree to not delete the App from my phone during the validity of this agreement and notify the lender if for any reasons my phone number changes. </li>
            </ol>
          </li>
          <li>
            <h4>Representations and Warranties of the Parties</h4>
            <p>Each Party to the Agreement makes the following representations and warranties with respect to itself, and confirms that they are, true, correct and valid:</p>
            <ol>
              <li>It has full power and authority to enter into, deliver and perform the terms and provisions of this agreement and, in particular, to exercise its rights, perform the obligations expressed to be assumed by and make the representations and warranties made by him hereunder;</li>

              <li>It obligation under this agreement are legal and valid binding on it and enforceable against it in accordance with this Agreement.</li>

              <li>The parties to the agreement warrant and represent that they have the legal competence and capacity to execute and perform this Agreement.</li>
            </ol>
          </li>
          <li>
            <h4>Disbursement of the Loan</h4>
            <ol>
              <li>The Lender will cause the Disbursement of the loan by online means into the bank account of the Borrower as specified by the Borrower in its loan application filled on the App after the acceptance of this Agreement by the Borrower within 2 working days.</li>
            </ol>
          </li>
          <li>
            <h4>Payment of the Application Processing Fees : </h4>
            <ol>
              <li>Borrower authorises the Lender to deduct the processing fees and applicable taxes payable to the Service Provider from the Disbursement Amount  and transfer the same to the Service Provider. The amount of processing fees will be as per the SCHEDULE OF LOAN SANCTION  TERMS.</li>
            </ol>
          </li>
          <li>
            <h4>Repayment of the Loan</h4>
            <ol>
              <li>Borrower will  be responsible for the required repayment amount in full as mentioned in the Schedule of Loan Sanction Terms, on or before the Due Date without any failure.</li>

              <li>Borrower undertakes to maintain sufficient balance in the account of the drawee bank for payment of e Mandate/ E NACH  issued by him on the day when the Repayment becomes due.</li>

              <li>The Loan is not renewable or extendable and is required to be paid in full including accrued interest, processing and other fees as recorded in the Schedule of Loan Sanction Terms.</li>
            </ol>
          </li>

          <li>
            <h4>Events of Defaults</h4>
            <p>The following events shall constitute 'Events of Default':</p>
            <ol>
              <li>The Borrower failing to complete the Repayment of the Loan or any fee, charges, or costs in the manner herein contained or any other amount due on or before the date on which it is due; or </li>

              <li>The death of the Borrower; or </li>

              <li>The Borrower becomes insolvent or bankrupt; or</li>

              <li>Any of the e Mandate/ E NACH / Post Dated Cheques  delivered or to be delivered by the Borrower to the Lender is not realized for any reason whatsoever on presentation; or </li>

              <li>Any instruction being given by the Borrower for Stop Payment of any e Mandate/ E NACH / Post Dated Cheques  for any reason whatsoever; or </li>
              <li>On the Borrower committing breach of any of the terms or representations made by the Borrower to the Lender under this Agreement or any other document submitted by the Borrower being found to be inaccurate or misleading.</li>
            </ol>
          </li>

          <li>
            <h4>Consequence of an Event of Default</h4>
            <ol>
              <li>
                <p>The Service Provider on behalf of the Lender or Lender will take such necessary steps as permitted by law against the Borrower to  realize the amounts due along with the interest at the decided rate and other fees / costs as agreed in this Agreement including appointment of collection agents, appointment of attorneys/ consultants, as it thinks fit; as well as</p>
                <p>Cost of initiating legal proceedings and collection charges, if any, incurred by lender, to be borne by the borrower.</p>
              </li>

              <li>In case e Mandate or E NACH is not realized, the Lender reserves the right to initiate proceedings under Section 25 of the Payment Settlement Act 2007 in addition to the recovery proceedings initiated for non-repayment. </li>
            </ol>
          </li>

          <li>
            <h4>Notices</h4>
            <p>All correspondence shall be addressed to the address as mentioned in the description of parties appearing in the preamble to this Agreement and the registered email addresses of the parties.</p>
          </li>

          <li>
            <h4>Severability</h4>
            <p>If any part of this Agreement is found to be invalid or unenforceable, then the invalid or unenforceable part will be deemed superseded by a valid enforceable part that most closely matches the intent of the original part and the remainder of the Agreement shall continue in effect.</p>
          </li>

          <li>
            <h4>Governing law, Dispute Resolution and Jurisdiction</h4>

            <ol>
              <li>Any dispute, which could not be settled by the parties through amicable settlement shall be finally settled by the court of law having jurisdiction to grant the same. Jurisdiction – New Delhi, Delhi.</li>
              
              <li>This agreement and the arrangements contemplated hereby shall in all respects be governed by and construed in accordance with the laws of India.</li>
            </ol>
          </li>

          <li>
            <h4>Binding Effect</h4>
            <p>All warranties, undertakings and representations given herein by the Parties shall be binding upon themselves and upon their legal representatives and estates. This Agreement (together with any amendments or modifications thereof) supersedes all prior discussions and agreements (whether oral or written) between the Parties with respect to the Loan.</p>
          </li>

          <li>
            <h4>Entire Agreement</h4>
            <p>This Agreement, along with the terms and conditions and the SCHEDULE OF LOAN SANCTION TERMS represents the entire agreement.</p>
          </li>

          <li>
            <h4>Miscellaneous</h4>
            <ol>
              <li>
                <p>Language</p>
                <p>English shall be used in all correspondence and communications between the Parties. </p>
              </li>

              <li>
                <p>Cumulative Rights</p>
                <p>All remedies of lender under this agreement whether provided herein or conferred by statute, civil law, common law, custom, trade, or usage are cumulative and not alternative and may be enforced successively or concurrently.</p>
              </li>

              <li>
                <p>Benefit of the Loan Agreement</p>
                <p>This Agreement shall be binding upon and to ensure to the benefit of each Party and its successors or heirs, administrators, as the case may be.</p>
              </li>

              <li>Any delay in exercising or omission to exercise any right, power or remedy accruing to the Lender under this Agreement or any other agreement or document shall not impair any such right, power or remedy and shall not be construed to be a waiver thereof or any acquiescence in any default; nor shall the action or inaction of the Lender in respect of any default or any acquiescence in any default, affect or impair any right, power or remedy of Lender in respect of any other default.</li>
            </ol>
          </li>
          <li>
            <h4>Acceptance</h4>
            <p>The parties hereby declares as follows: </p>
            <ol>
              <li>They have read the entire Agreement and shall be bound by all the conditions.</li>

              <li>The Agreement is presented in the form of electronic text in the App and will be executed by clicking on the tabs or prompts presented for the acceptance of the Agreement.</li>

              <li>They agree that this Agreement shall be concluded and becomes legally binding on the date when it is accepted by the Borrower by means of prompts presented on the App for acceptance.</li>
            </ol>
          </li>
        </ol>
        <p>IN WHEREOF the Parties have executed this Agreement as of  [{ localDate }] by means of adding their acceptance on the App where they have logged in with their valid credentials using their registered phone number and/or email IDs.</p>

        <h5>Borrower: [{ userName }]</h5>
        <h5>Lender: [X10 Financial Services Limited]</h5>

        {/* Loan Sanction Letter */}
        <h2>Loan Sanction Letter</h2>
        <p>Dear Applicant,</p>
        <p>Thank you for your Loan Application made through Mobile App <b>[RSKASH]</b> .</p>

        <ol>
          <li>
            <p>We are pleased to sanction you a loan as per the enclosed terms and details.</p>
            <h5 className="center">Schedule of Loan Sanction Terms</h5>

            <div className='body-table'>
              <table>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>ITEM</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  { tableMsg }
                </tbody>
              </table>
            </div>
          </li>

          <li>Please note that this sanction letter is issued in response to your loan application and based on the information you have provided in your application. </li>

          <li>The Processing fees as charged by the Service Provider <b>[X10 Financial Services Limited, RsKash]</b> is mentioned above and the same will be deducted from your loan amount.</li>

          <li>You are under no obligation to accept the sanctioned loan. If you do not accept the sanction letter and the enclosed agreement your loan application will be considered withdrawn and you will not be liable to pay any processing fees. </li>

          <li>If you wish to accept the sanction letter please go through the enclosed Loan agreement and confirm your acceptance of the agreement and the Terms of Sanction.</li>

          <li>The loan will be disbursed to your designated bank account after confirmation of your acceptance of this sanction letter  and completion of the loan agreement on the <b>[RSKASH]</b> App.</li>
        </ol>

        {/* <p>&nbsp;</p> */}
        <p>Yours truly,</p>
        <h4>For X10 Financial Services Limited</h4>
        <p>Loan Officer </p>
        <p>Email: RsKash.app@x10corp.com</p>
      </Flex.Item>
    </Flex>
  }
}

export default RskashLoanContract;

